import { render, staticRenderFns } from "./CoaDetail.vue?vue&type=template&id=335f0214&scoped=true&"
import script from "./CoaDetail.vue?vue&type=script&lang=js&"
export * from "./CoaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoaDetail.vue?vue&type=style&index=0&id=335f0214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f0214",
  null
  
)

export default component.exports